/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */

/**
 * Company Configuration
 *
 * Global configuration values for company information used across the application.
 */
export const karyaConfig = {
  name: 'DAIA Tech Pvt. Ltd.',
  email: 'sales@karya.in',
  officeAddress: `60/1, 9th Main, 14th Cross,
Off CMH Road,
Bengaluru, Karnataka 560038`,
} as const;
